/* unplugin-vue-components disabled */import script from "./CouponDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponDetails.vue?vue&type=script&setup=true&lang=js"

import "./CouponDetails.vue?vue&type=style&index=0&id=d917394a&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d917394a"]])

export default __exports__